import React from "react"

const appendDots = (dots, maxDots = 5) => {
    const totalDots = dots.length
    if (totalDots <= maxDots) {
        return <ul>{dots}</ul>
    }
    const currentIndex = dots.findIndex(dot => dot.props.className.includes("slick-active"))
    let start = Math.max(0, currentIndex - Math.floor(maxDots / 2))
    let end = start + maxDots
    if (end > totalDots) {
        end = totalDots
        start = end - maxDots
    }
    const visibleDots = dots.slice(start, end)
    return <ul>{visibleDots}</ul>
}

export { appendDots }
